import { IonSpinner, IonButton, useIonRouter, IonChip, IonToolbar, IonText, IonAvatar, IonCol, IonIcon, IonImg, IonItem, IonLabel, IonNote, IonRow, IonThumbnail, IonRippleEffect } from '@ionic/react';
import { logoYoutube, heartCircle, chatboxOutline, heartCircleOutline, heartOutline, chatbubbleEllipses, earth, heart } from 'ionicons/icons';
import { ContentInfo, ContentInterface, ContentUpdateInt } from '../data/item';
import React, { Component }  from 'react';

import ActionComp from '../components/ActionComp'; 
import UserBar from '../components/UserBar'; 
import LikeBar from '../components/LikeBar'; 
import { LANGUAGE, GetStr } from "../language/Language";
import { ReadyAds, ShowAds } from "../components/Admob";

import '../pages/Main.css'; 

  
const VideoContent : React.FC<ContentUpdateInt> = ({ content, index, onUpdate, view, autoplay }) => {
    
    const router = useIonRouter();

    // click on content
    const showContent = async () => {
        if (content.locked < 1 && view == "def")
        {
            let ready = await ReadyAds();
            if (!ready)
                router.push("/content/" + content.id + "/n", "forward", "push");
            else
            {
                ShowAds( () => {
                    router.push("/content/" + content.id + "/ad", "forward", "push");
                });
            }
        }
    }

    return (
        <div className="video-content">
            <UserBar content={content} index={index} onUpdate={onUpdate} view={view} autoplay={autoplay} />
            <div className="lock-wrapper" onClick={showContent}>    
                {
                    /* for content locked */
                    content.locked > 1 ?
                <div className="video-lock">
                    {
                        content.opening ?
                    <IonSpinner name="lines-sharp" color="success" />
                        :
                    <IonIcon icon={heartCircle} size="large" />
                    }<br/>
                    { GetStr(LANGUAGE.TXT_SUPERLIKE_TO_UNLOCK) }
                </div>
                    :
                    content.locked == 1 ?
                <div className="video-lock">
                    {
                        content.opening ?
                    <IonSpinner name="lines-sharp" color="success" />
                        :
                    <IonIcon icon={heart} size="large" />
                    }<br/>
                    { GetStr(LANGUAGE.TXT_LIKE_TO_UNLOCK) }
                </div>
                    :
                <div/>
                }

                {
                    view == "full" ?
                <div>
                    {
                        content.images.length > 0 ?
                    <iframe 
                        className="video-player"
                        src={"https://www.youtube.com/embed/" +  content.images[0] + "?autoplay=" + (autoplay ? 1 : 0) + "&rel=0"} 
                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" 
                        allowFullScreen
                        frameBorder="0"
                    />
                        :
                    <div className="video-error-view">
                        <i>{ GetStr(LANGUAGE.TXT_VIDEO_CONTENT_ERROR) }</i>
                    </div>
                    }
                </div>
                    :
                <div className="video-parent">
                    <img className="video-thumbnail" src={content.thumbnail} />
                    <IonIcon className="video-icon" color="danger" icon={logoYoutube} />
                </div>
                }
            </div>
            
            <IonItem lines="none" onClick={showContent}>
                <IonLabel className="ion-text-wrap">
            {
                content.title != "" ?
                <IonText className="content-title">{content.title}<br/></IonText>
                :
            <div/>
            }

            {
                content.desc != "" ?
                <IonText className="content-desc">{content.desc}</IonText>
                :
            <div/>
            }
                </IonLabel>
            </IonItem>

            <ActionComp content={content} />
            <LikeBar content={content} index={index} onUpdate={onUpdate} view={view} autoplay={autoplay} />
        </div>
    );
};
  
export default VideoContent;